import React, { FC } from 'react';

import { useMobile, useTablet, useMediaSwitch, useDesktop, Typography, Box, Stack, ExternalUp24 } from 'Modules/ui3';

import { DFALogo } from '../../icons';
import { getIdFromAnchor } from '../../utils';
import { landingAnchorRoutes } from '../../routes/landingAnchorRoutes';
import { AdditionaInfo, Address, Contacts, Links } from './components';


const scrollToTop = () => {
    if ('scrollTo' in window) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    } else
        window.scroll(0, 0);
};


export const Footer: FC = () => {
    const isDesktop = useDesktop();
    const isTablet = useTablet();
    const isMobile = useMobile();

    const dfaLogoHeight = useMediaSwitch(25, 20, 20);

    return (
        <Stack
            margin='0 auto'
            maxWidth='1440px'
            id={getIdFromAnchor(landingAnchorRoutes.contacts.route)}
            borderTop='2px solid'
            borderColor='grayscale.shade40'
            py={useMediaSwitch(14, 12, 10)}
            px={useMediaSwitch(7, 5, 3)}
            direction={useMediaSwitch('row', 'column', 'column')}
            spacing={7}
            height={isDesktop ? ({ spacing }) => spacing(74) : '100%'}
        >
            {
                isDesktop
                    ? (
                        <>
                            <Stack
                                alignItems='start'
                                justifyContent='space-between'
                                height='100%'
                            >
                                <DFALogo height={dfaLogoHeight} />

                                <AdditionaInfo />
                            </Stack>

                            <Contacts />

                            <Address />

                            <Stack>
                                <Stack direction='row' justifyContent='center' alignItems='center' onClick={scrollToTop} sx={{ ':hover': { cursor: 'pointer' } }}>
                                    <ExternalUp24 sx={{ fontSize: 36, color: 'general.primary50' }} />
                                    <Typography variant='regularHeader2' color='general.primary50'>Наверх</Typography>
                                </Stack>
                            </Stack>
                        </>
                    )
                    : (
                        <>
                            <Box height='100%'>
                                <DFALogo height={dfaLogoHeight} />
                            </Box>

                            <Contacts />

                            <Stack
                                direction='row'
                                spacing={10}
                                justifyContent='space-between'
                                height={isMobile ? '100px' : '100%'}
                            >
                                <Links links={['issuers', 'investors', 'partners']} />
                                <Links links={['registration', 'documents', 'news']} />

                                {isTablet && <Address />}
                            </Stack>

                            {isMobile && <Address />}

                            <AdditionaInfo />
                        </>
                    )
            }
        </Stack>
    );
};
